import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faGlobe } from '@fortawesome/free-solid-svg-icons';
import './Project.css';
import { Markup } from 'interweave';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';
import { Badge } from 'react-bootstrap';

const Project = ({ project }) => {

    const { title, thumbnail, description, liveSite, github, technology, serial } = project;

    return (
        <div className="mt-5 ml-3 mr-3">
            <div className="row single-project d-flex align-items-center">
                <div className="col-md-6">
                    <div id={`carouselExampleIndicators${serial}`} className="carousel slide" data-ride="carousel">
                        <ol class="carousel-indicators">
                            {/* {
                                thumbnail.map((thumb, index) =>
                                    <li data-target={`#carouselExampleIndicators${serial}`} data-slide-to={index} className={`${index == 0 ? "active" : ""}`}></li>
                                )
                            } */}
                            <li data-target={`#carouselExampleIndicators${serial}`} data-slide-to="0" class="active"></li>
                            <li data-target={`#carouselExampleIndicators${serial}`} data-slide-to="1"></li>
                            <li data-target={`#carouselExampleIndicators${serial}`} data-slide-to="2"></li>
                        </ol>
                        <div className="carousel-inner">
                            {/* {
                                thumbnail.map( img => 
                                    <div className="carousel-item active">
                                        <img className="d-block w-100" src={img} alt="project thumbnail" />
                                    </div>
                                )
                            } */}
                            <div className="carousel-inner">
                                <div className="carousel-item active">
                                    <img className="d-block w-100" src={thumbnail[0]} alt="First slide" />
                                </div>
                                <div className="carousel-item">
                                    <img className="d-block w-100" src={thumbnail[1]} alt="Second slide" />
                                </div>
                                <div className="carousel-item">
                                    <img className="d-block w-100" src={thumbnail[2]} alt="Third slide" />
                                </div>
                            </div>
                        </div>
                        <a className="carousel-control-prev" href={`#carouselExampleIndicators${serial}`} role="button" data-slide="prev">
                            <span className="svg-icons-slider"><NavigateBeforeIcon /></span>
                        </a>
                        <a className="carousel-control-next" href={`#carouselExampleIndicators${serial}`} role="button" data-slide="next">
                            <span className="svg-icons-slider"><NavigateNextIcon /></span>
                        </a>
                    </div>
                    <h4 style={{ color: '#1a3d5d', fontWeight: '700' }} className="mt-2 mb-2">Technology</h4>
                    <div>
                        {
                            technology.map(tech => <h5 className="d-inline"><Badge className="mr-2 mb-1 p-2" variant="secondary">{tech}</Badge></h5>)
                        }
                    </div>
                    <div className="project-footer">
                        <a href={liveSite} target="_blank"><button className="custom-btn mr-3 mt-3"><FontAwesomeIcon icon={faGlobe} /> &nbsp;Live</button></a>
                        <a href={`${github}`} target="_blank"><button className="github-btn"><FontAwesomeIcon icon={['fab', 'github']} /> &nbsp;Github</button></a>
                    </div>
                </div>
                <div className="col-md-6">
                    <h2 style={{ color: '#1a3d5d', fontWeight: '700' }}>{title}</h2>
                    <Markup content={description} />
                </div>
            </div>
        </div>
    );
};

export default Project;